import * as yup from 'yup';

export const getCreateConsultFirstStepSchema = yup.object().shape({
  title: yup.string().required('Ce champs est requis'),
  ref: yup.string(),
  // type: yup.string().required('Ce champs est requis'),
  fieldOfActivity: yup.string().required('Ce champs est requis'),
  address: yup.string().required('Ce champs est requis'),
  city: yup.string().required('Ce champs est requis'),
  postalCode: yup.string().required('Ce champs est requis'),
  department: yup.string().required('Ce champs est requis'),
  region: yup.string().required('Ce champs est requis'),
  useActualAddress: yup.boolean(),
  is_premium: yup.boolean(),
});
